<template lang="pug">
el-dialog(title="重置密码" :visible="passwordResetFormVisible" :before-close="hidePasswordResetForm")
    el-form(:model="form" :rules="resetRules" ref="form")
        el-form-item(label="新密码" prop="password" label-width="120px")
            el-input(type="password" v-model="form.password")
        el-form-item(label="确认新密码" prop="confirmPass" label-width="120px")
            el-input(type="password" v-model="form.confirmPass")
    .dialog-footer(slot="footer")
        el-button(@click="hidePasswordResetForm") 取 消
        el-button(type="primary", @click="submit", :loading="loading") 确 定
</template>

<script>
// @ is an alias to /src
import { updateOrgMemberAPI } from "@/services";
const defaultForm = {
    password: "",
    confirmPass: ""
};
export default {
    name: "member-password-reset-form",
    props: ["passwordResetFormVisible", "editingMember", "orgname"],
    data() {
        const validatePassSecure = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.form.confirmPass !== "") {
                    this.$refs.form.validateField("confirmPass");
                }
                callback();
            }
        };
        const validatePassConfirm = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.form.password) {
                callback(new Error("两次输入密码不一致"));
            } else {
                callback();
            }
        };
        return {
            loading: false,
            form: Object.assign({}, defaultForm),
            resetRules: {
                password: [
                    {
                        min: 8,
                        max: 64,
                        message: "密码长度不得小于8",
                        trigger: "blur"
                    },
                    {
                        required: true,
                        validator: validatePassSecure,
                        trigger: "blur"
                    }
                ],
                confirmPass: [
                    {
                        required: true,
                        validator: validatePassConfirm,
                        trigger: "change"
                    }
                ]
            },
            orgRoleOptions: [
                {
                    value: "owner",
                    label: "组织所有人",
                    disabled: true
                },
                {
                    value: "admin",
                    label: "组织管理员",
                    disabled: false
                },
                {
                    value: "member",
                    label: "组织成员",
                    disabled: false
                }
            ]
        };
    },
    methods: {
        /**
         * Backend Service API Func Wrapper
         */
        async updateOrgMember() {
            this.loading = true;
            try {
                const res = await updateOrgMemberAPI(
                    this.orgname,
                    this.editingMember.name,
                    this._.pickBy(this.form, this._.identity)
                );
                if (res.status === 200) {
                    this.$message.success("保存成功");
                } else {
                    throw err;
                }
            } catch (err) {
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        /**
         * UI Control
         */
        hidePasswordResetForm() {
            this.$emit("hidePasswordResetForm");
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    console.log("error submit!!");
                    return false;
                }
                this.updateOrgMember();
                this.form = Object.assign({}, defaultForm);
                this.hidePasswordResetForm();
            });
        }
    },
    watch: {
        passwordResetFormVisible(val) {
            if (val && this.editingMember) {
                this.form = Object.assign({}, defaultForm, this.editingMember);
            } else if (val && !this.editingMember) {
                this.form = Object.assign({}, defaultForm);
            }
        }
    },
    mounted() {}
};
</script>
<style lang="stylus" scoped>
.el-select {
    width: 100%;
}
</style>
